import axios from 'axios';
import { ISubmitPayoutPayload } from 'shop';

export class ShopApi {
  public static ENDPOINT = '/api/shop';

  public static submitPayout = (payload: ISubmitPayoutPayload) =>
    axios.post(`${ShopApi.ENDPOINT}/submit-payout`, payload);
}
